import { CheckCircle } from 'lucide-react';
import { Button } from '@zaogig/ui/button';
import { Badge } from '@zaogig/ui/badge';
import type { CheckInResultData } from '../../hooks/use-attendance-state';

interface CheckInSuccessPhaseProps {
  result: CheckInResultData;
  onStartWork: () => void;
}

export function CheckInSuccessPhase({ result, onStartWork }: CheckInSuccessPhaseProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6">
      <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mb-6">
        <CheckCircle className="w-12 h-12 text-green-600" />
      </div>
      <h2 className="text-xl font-bold text-gray-800 mb-2">上班打卡成功</h2>
      <p className="text-gray-500 text-center mb-6">
        {result.taskUnderstandingScore && (
          <Badge className="mb-2">
            任务理解度: {result.taskUnderstandingScore}分
          </Badge>
        )}
        <br />
        {new Date().toLocaleTimeString('zh-CN', {
          hour: '2-digit',
          minute: '2-digit'
        })}
      </p>

      {result.gpsPassed !== undefined && (
        <div className="flex gap-2 mb-6">
          <Badge variant={result.gpsPassed ? 'default' : 'destructive'}>
            GPS {result.gpsPassed ? '正常' : '异常'}
          </Badge>
          {result.voicePassed !== undefined && (
            <Badge variant={result.voicePassed ? 'default' : 'destructive'}>
              声纹 {result.voicePassed ? '通过' : '未验证'}
            </Badge>
          )}
        </div>
      )}

      <Button
        onClick={onStartWork}
        className="w-full bg-blue-600 hover:bg-blue-700"
      >
        开始工作
      </Button>
    </div>
  );
}
